export default {
    //invitations
    invitations: 0,
    invitationsPeriod: 0,
    flyers: 0,
    flyersUsed: 0,
    flyersPeriod: 0,
    flyersUsedPeriod: 0,
    expiredInvitations: 0,
    expiredFlyers: 0,
    expiredInvitationsPeriod: 0,
    expiredFlyersPeriod: 0,

    //parameters
    weight: null,
    waist: null,

    //users funnel
    connectedWithTherapist: 0,
    connectedWithTherapistToolTip: {},
    inApp: 0,
    onboarding: 0,
    inactivated: {},
    connectedWithTherapistInPeriod: {},
    inAppInPeriod: 0,
    onboardingInPeriod: 0,
    onboardingPendingInPeriod: 0,
    inactivatedInPeriod: {},
    connectedWithTherapistEvent: 0,
    connectedWithTherapistEventSustain: 0,
    connectedWithTherapistEventGraduate: 0,
    inAppEvent: 0,
    onboardingEvent: 0,
    onboardingPendingEvent: 0,
    inactivatedEvent: {},
    
    //doctors
    allDoctors: [],

    //filter
    filterCompaniesAPI: [],
    filterDateFromAPI: '',
    filterDateToAPI: '',
  }
  